const Silver = [
    {
        elementType: 'labels.icon',
        stylers: [{ visibility: 'off' }],
    },
];

export default Silver;
